import React from 'react';
import { ScoreContainer } from './StarRatingBar.styles';

interface Review {
  score: number;
  [key: string]: any;
}

interface StarCounts {
  "1": number;
  "2": number;
  "3": number;
  "4": number;
  "5": number;
}

interface StarRatingBarProps {
  reviews?: Review[];
  starCounts?: StarCounts;
}

const StarRatingBar: React.FC<StarRatingBarProps> = ({ reviews, starCounts }) => {
  const barScores = [5, 4, 3, 2, 1];

  const calculateBarWidth = (score: number): { width: number; count: number } => {
    // If starCounts is provided, use it directly
    if (starCounts) {
      const scoreCount = starCounts[score.toString() as keyof StarCounts];
      const totalReviews = Object.values(starCounts).reduce((sum, count) => sum + count, 0);

      if (totalReviews === 0 || scoreCount === 0) {
        return { width: 0, count: 0 };
      }

      return { width: (scoreCount / totalReviews) * 100, count: scoreCount };
    }

    // Fallback to calculating from reviews array
    if (!reviews) {
      return { width: 0, count: 0 };
    }

    const totalReviews = reviews.length;
    const scoreCount = reviews.filter((review) => review.score === score).length;

    if (totalReviews === 0 || scoreCount === 0) {
      return { width: 0, count: 0 };
    }

    return { width: (scoreCount / totalReviews) * 100, count: scoreCount };
  };

  return (
    <ScoreContainer>
      {barScores.map((barScore, index) => {
        const { width, count } = calculateBarWidth(barScore);
        return (
          <div key={index} className="review-item">
            <div className="rating">{barScore}점</div>
            <div className="bar">
              <div className="empty-bar"></div>
              {(starCounts || (reviews && reviews.length > 0)) && (
                <div
                  className="filled-bar"
                  style={{
                    width: `${width}%`,
                  }}
                ></div>
              )}
            </div>
            <div className="review-count">{count}개</div>
          </div>
        );
      })}
    </ScoreContainer>
  );
};

export default StarRatingBar;
